export default __webpack_public_path__ + "static/media/EDSFhome.cdbaa0ce.md";